import type { ReactNode } from 'react'
import { BrandLoader } from '@/components/common/BrandLoader'
import type { ReviewRead } from '@/features/moderation/types'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  kind: ReviewRead['kind']
  /** Курс открыт ученикам — тогда текст говорит, что они пока видят прежнюю версию. */
  live: boolean
  /** Свои заголовок и строка (статья говорит о читателях, а не учениках). */
  title?: string
  body?: string
  /** Действия под полоской — у статьи «Отозвать заявку». */
  children?: ReactNode
}

/** Идёт проверка: тот же серый блок, где только что была кнопка отправки. */
export const ReviewingUpdate = ({ kind, live, title, body, children }: Props) => {
  const m = useMessages(messages)
  const isUpdate = kind === 'update'
  return (
    <section role="status" className="space-y-3 rounded-2xl bg-foreground/5 p-5">
      <div className="flex items-center gap-2.5">
        <BrandLoader className="size-5 shrink-0" />
        <h3 className="text-base font-medium">
          {title ?? (isUpdate ? m.reviewingUpdateTitle : m.reviewingCourseTitle)}
        </h3>
      </div>
      <p className="text-sm text-muted-foreground">
        {body ?? (isUpdate && live ? m.reviewingUpdateBody : m.reviewingCourseBody)}
      </p>
      {/* Бегущая полоска: проверка идёт, срок не обещаем. */}
      <div className="h-1 overflow-hidden rounded-full bg-foreground/10">
        <div className="h-full w-1/3 animate-[review-progress_1.6s_ease-in-out_infinite] rounded-full bg-brand" />
      </div>
      {children}
    </section>
  )
}
